import { type ReactNode } from "react"
import { cn } from "~/utils/helpers"

export interface HeaderProps {
  children: ReactNode
  className?: string
}

export interface HeaderTitleProps {
  title?: string
}

const Header = ({ children, className }: HeaderProps) => {
  return (
    <div
      className={`sticky top-0 z-10 max-h-header min-h-header bg-background border-b border-base flex justify-start gap-3 items-center px-4 py-3`}
    >
      <div className={cn("flex flex-row w-full justify-between gap-3 items-center", className)}>
        {children}
      </div>
    </div>
  )
}

const HeaderTitle = ({ title }: HeaderTitleProps) => {
  return <span className="text-md font-medium">{title}</span>
}

export { Header, HeaderTitle }
